module.exports = __webpack_public_path__ + "static/img/contact.fe3e736b.png";